import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { SelectCurrencyComponent } from './select-currency.component';
import { SharedModule } from '../shared.module';
import { CurrencyCountryPipeModule } from '@pipes/currency-country/currency-country.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [SelectCurrencyComponent],
  imports: [
    SharedModule,
    MatSelectModule,
    FormsModule,
    MatProgressSpinnerModule,
    CurrencyCountryPipeModule,
  ],
  exports: [SelectCurrencyComponent],
})
export class SelectCurrencyModule {}
